<template>
  <div class="box" :class="client == 'Android' ? 'androidBox' : ''">
    <div class="link_gift_desBox">
      <span class="closeBtn" @click="returnBtn"></span>
        <header>{{ $t('guanxi_gift_rule_title') }}</header>
        <p>{{ $t('relastionship.des.1') }}</p>
        <p>{{ $t('relastionship.des.2') }}</p>
        <p>{{ $t('relastionship.des.3') }}</p>
        <p>{{ $t('relastionship.des.4') }}</p>
        <table border="1" cellspacing="0" width="100%">
        <tr>
          <td class="td">{{ $t("relastionship.des.5") }}</td>
          <td class="td">{{ $t("relastionship.des.6") }}</td>
        </tr>
        <tr>
          <td>8</td>
          <td>1</td>
        </tr>
        <tr>
          <td>9</td>
          <td>1</td>
        </tr>
        <tr>
          <td>10</td>
          <td>2</td>
        </tr>
        <tr>
          <td>11</td>
          <td>2</td>
        </tr>
        <tr>
          <td>12</td>
          <td>3</td>
        </tr>
        <tr>
          <td>13</td>
          <td>3</td>
        </tr>
        <tr>
          <td>14</td>
          <td>4</td>
        </tr>
        <tr>
          <td>15</td>
          <td>4</td>
        </tr>
      </table>
    </div>
  </div>
  </template>
  
  <script>
  export default {
    name: "link_gift_des",
    data() {
      return {
        client:'',
        langType:'en'
      };
    },
    created() {
        this.parseLangType();
        this.language();
        this.judgeClient();
    },
    mounted() {
    },
    methods: { 
        // 关闭webview半开
        returnBtn() {
            this.$completes.complete("getPreviousPage");
        },
        // 判断平台
        judgeClient() {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
            this.client = 'iOS';
        } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
            this.client = 'Android';
        } else {
            this.client = 'PC';
        }
        return this.client;
        },
        // 解析语言类型，兼容所有格式
        parseLangType() {
          const query = this.$route.query;
          
          // 1. 标准方式：直接有 langType 参数
          if (query.langType) {
            this.langType = query.langType;
            return;
          }
          
          // 2. 处理错误格式：isShowNav 参数包含 langType
          if (query.isShowNav) {
            let value = query.isShowNav.toString();
            
            // 解码 URL 编码的 ?
            if (value.includes('%3F') || value.includes('%3f')) {
              value = decodeURIComponent(value);
            }
            
            // 检查是否包含 langType
            if (value.includes('langType=')) {
              // 提取 langType 值
              const match = value.match(/langType=([^&]+)/);
              if (match && match[1]) {
                this.langType = match[1];
                return;
              }
            }
          }
          
          // 3. 默认值
          this.langType = 'en';
        },
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else if (langs == "fr") {
              this.$i18n.locale = "fr"
            } else if (langs == "id") {
              this.$i18n.locale = "id"
            } else if (langs == "ms") {
              this.$i18n.locale = "ms"
            } else {
                this.$i18n.locale = "en";
            }
            document.title = this.$t('guanxi_gift_rule_title')
             document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
html[lang="ar"] .link_gift_desBox {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .box{
    background-image: linear-gradient(to bottom,#B481FF,#8959DB);
  }
  .link_gift_desBox{
    font-family: 'Montserrat';
    padding: 40px;
    padding-top: 50px;
    width: 100%;
    min-height: 100vh;
    background: url('../../assets/link_gift_des/bg.png') no-repeat;
    background-size: 640px 576px;
    box-sizing: border-box;
    color: #fff;
    position: relative;
    background-position: bottom;
    /* overflow-y: auto; */
  }
  .link_gift_desBox header{
    font-size: 34px;
    font-weight: 600;
    margin-bottom: 28px;
    text-align: center;
    margin-top: env(safe-area-inset-top);
  }
  .link_gift_desBox p{
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 28px;
  }
  .closeBtn{
    position: absolute;
    top: calc(45px + env(safe-area-inset-top));
    right: 40px;
    width: 22px;
    height: 19px;
    background: url('../../assets/link_gift_des/close.png') no-repeat;
    background-size: 100% 100%;
  }
  .androidBox .link_gift_desBox header{
    margin-top: 30px;
  }
  .androidBox  .closeBtn{
    top: 68px;
  }

table {
  line-height: 25px;
  text-align: center;
  border: 1px solid #fff;
  font-size: 28px;
}
td {
  width: 50%;
  padding-left: 5px;
  border: 1px solid #fff;
  padding: 20px 0;
}
  </style>
  